import { toast } from "react-toastify";

import { portScanner } from "@forproxyband/react-tools";

import getUserIp from "./getUserIp";

export const handleIp = async setFormData => {
  const ip = await getUserIp();
  if (ip) {
    setFormData(prevData => ({
      ...prevData,
      ip,
    }));
  }
};

export const handleChange = (event, setFormData) => {
  const { name, value } = event.target;
  setFormData(prevFormData => ({ ...prevFormData, [name]: value }));
};

export const handlePortScan = (
  e,
  form,
  formData,
  setShowLoader,
  setResponseFromServer,
  t,
) => {
  e.preventDefault();

  if (!formData.ip.trim()) {
    return toast.error(t("traceIp.incorrectIp"));
  }
  setResponseFromServer(null);
  setShowLoader(true);

  const responseCallback = res => {
    setResponseFromServer(res);
  };
  const catchErrorMessage = () => {
    setShowLoader(false);
    toast.error(t("global.error"));
  };
  const emptyIpError = () => {
    setShowLoader(false);
    toast.error(t("traceIp.incorrectIp"));
  };

  if (form.current) {
    const formDataForm = new FormData(form.current);

    portScanner.scanner(
      formDataForm,
      responseCallback,
      () => {},
      "TCP UDP",
      formData.portType || "POPULAR",
      catchErrorMessage,
      emptyIpError,
    );
  }
};
